/* eslint-disable max-len,no-irregular-whitespace,no-console */
import React from 'react';
import DrWatsonLargeLogo from '../../components/DrWatsonLargeLogo';
import Layout from '../../components/Layout';
import SEO from '../../components/seo';
import NavBar from '../../components/NavBar';
import Footer from '../../components/Footer';
import './style.scss';
import getCloudinary from '../../utils/getCloudinary';

const imageSize = 200;
const certificateProducts = [
    {
        name: 'Berry Kush',
        type: 'E-Liquids',
        certificates: [
            {
                variant: '100mg',
                image: getCloudinary().url(
                    'jinj5nhmlhuogi8a0rfc',
                    { height: imageSize, crop: 'fit', fetch_format: 'auto' },
                ),
                certificateFile: 'Berry Kush 100mg.pdf',
            },
            {
                variant: '300mg',
                image: getCloudinary().url(
                    'mb0q1g3obprcw5sdjgcu',
                    { height: imageSize, crop: 'fit', fetch_format: 'auto' },
                ),
                certificateFile: 'Berry Kush 300mg.pdf',
            },
            {
                variant: '600mg',
                image: getCloudinary().url(
                    'h1gxud6ih7jhd9nj8b5j',
                    { height: imageSize, crop: 'fit', fetch_format: 'auto' },
                ),
                certificateFile: 'Berry Kush 600mg.pdf',
            },
        ],
    },
    {
        name: 'Lemon Haze',
        type: 'E-Liquids',
        certificates: [
            {
                variant: '100mg',
                image: getCloudinary().url(
                    'wwu9b8qn15iid1spvhwe',
                    { height: imageSize, crop: 'fit', fetch_format: 'auto' },
                ),
                certificateFile: 'Lemon Haze 100mg.pdf',
            },
            {
                variant: '300mg',
                image: getCloudinary().url(
                    'kgjiah3numxj60ywgkhe',
                    { height: imageSize, crop: 'fit', fetch_format: 'auto' },
                ),
                certificateFile: 'Lemon Haze 300mg.pdf',
            },
            {
                variant: '600mg',
                image: getCloudinary().url(
                    'vwmafglrgxtkf5jy8jul',
                    { height: imageSize, crop: 'fit', fetch_format: 'auto' },
                ),
                certificateFile: 'Lemon Haze 600mg.pdf',
            },
        ],
    },
    {
        name: 'Menthol',
        type: 'E-Liquids',
        certificates: [
            {
                variant: '100mg',
                image: getCloudinary().url(
                    'y3tiij6yp5hbd2iw0ewo',
                    { height: imageSize, crop: 'fit', fetch_format: 'auto' },
                ),
                certificateFile: 'Menthol 100mg.pdf',
            },
            {
                variant: '300mg',
                image: getCloudinary().url(
                    'ih5dytow3nufum5yq9mw',
                    { height: imageSize, crop: 'fit', fetch_format: 'auto' },
                ),
                certificateFile: 'Menthol 300mg.pdf',
            },
            {
                variant: '600mg',
                image: getCloudinary().url(
                    'kvvuvfcdetbtyocbydp5',
                    { height: imageSize, crop: 'fit', fetch_format: 'auto' },
                ),
                certificateFile: 'Menthol 600mg.pdf',
            },
        ],
    },
    {
        name: 'Strawberry Diesel',
        type: 'E-Liquids',
        certificates: [
            {
                variant: '100mg',
                image: getCloudinary().url(
                    'lemmcqy8dirqcmnqrxvh',
                    { height: imageSize, crop: 'fit', fetch_format: 'auto' },
                ),
                certificateFile: 'Strawberry Diesel 100mg.pdf',
            },
            {
                variant: '300mg',
                image: getCloudinary().url(
                    'vjxxps8vszlfmc4gw3cf',
                    { height: imageSize, crop: 'fit', fetch_format: 'auto' },
                ),
                certificateFile: 'Strawberry Diesel 300mg.pdf',
            },
            {
                variant: '600mg',
                image: getCloudinary().url(
                    'kr5nc09frbta4q9xv70e',
                    { height: imageSize, crop: 'fit', fetch_format: 'auto' },
                ),
                certificateFile: 'Strawberry Diesel 600mg.pdf',
            },
        ],
    },

    {
        name: 'Amalfi Lemon',
        type: 'Pods',
        certificates: [
            {
                variant: 'Single',
                image: getCloudinary().url(
                    'fxjgdsthpcngf30p3zfr',
                    { height: imageSize, crop: 'fit', fetch_format: 'auto' },
                ),
                certificateFile: 'Amalfi Lemon POD 600mg.pdf',
            },
        ],
    },
    {
        name: 'Berry Kush',
        type: 'Pods',
        certificates: [
            {
                variant: 'Single',
                image: getCloudinary().url(
                    'uxir6jeucizhpqcgd9ac',
                    { height: imageSize, crop: 'fit', fetch_format: 'auto' },
                ),
                certificateFile: 'Berry Kush POD 600mg.pdf',
            },
        ],
    },
    {
        name: 'Brazilian Mango',
        type: 'Pods',
        certificates: [
            {
                variant: 'Single',
                image: getCloudinary().url(
                    'logbe5myuljlrl5dtrjg',
                    { height: imageSize, crop: 'fit', fetch_format: 'auto' },
                ),
                certificateFile: 'Brazlian Mango POD 600mg.pdf',
            },
        ],
    },
    {
        name: 'Iced Peach',
        type: 'Pods',
        certificates: [
            {
                variant: 'Single',
                image: getCloudinary().url(
                    'sqwhbivlyiypzqtdsz72',
                    { height: imageSize, crop: 'fit', fetch_format: 'auto' },
                ),
                certificateFile: 'Iced Peach POD 600mg.pdf',
            },
        ],
    },
    {
        name: 'Wild Mint',
        type: 'Pods',
        certificates: [
            {
                variant: 'Single',
                image: getCloudinary().url(
                    'dtwe7legq7ovwhtokc6y',
                    { height: imageSize, crop: 'fit', fetch_format: 'auto' },
                ),
                certificateFile: 'Wild Mint POD 600mg.pdf',
            },
        ],
    },
    {
        name: 'CBD',
        type: 'Misc',
        certificates: [
            {
                variant: 'Oil',
                image: getCloudinary().url(
                    'jinj5nhmlhuogi8a0rfc',
                    { height: imageSize, crop: 'fit', fetch_format: 'auto' },
                ),
                certificateFile: 'CBD-Oil-Extract.pdf',
            },
            {
                variant: 'Isolate',
                image: getCloudinary().url(
                    'mb0q1g3obprcw5sdjgcu',
                    { height: imageSize, crop: 'fit', fetch_format: 'auto' },
                ),
                certificateFile: 'CBD-Vape-Isolate.pdf',
            },
        ],
    },
];

const CertificatesPage = () => (
    <Layout id="certificates-page">
        <SEO title="DR WATSON CBD Certificates" />
        <DrWatsonLargeLogo />
        <NavBar />

        <div className="nav-bar-below-content container main-certificates-container">
            <div className="subtitle is-size-4-touch is-size-3-desktop ">Lab Certificates</div>

            {
                certificateProducts.map(certificateProduct => (
                    <div className="box certificate-product">
                        <div className="title is-size-5-touch is-size-4-desktop">
                            {`${certificateProduct.name} ${certificateProduct.type}`}
                        </div>
                        <table className="table is-bordered is-striped is-hoverable is-fullwidth">
                            <thead>
                                <tr>
                                    <th
                                        className="is-size-5-touch is-size-4-desktop"
                                    >
                                    Name
                                    </th>
                                    <th />
                                </tr>
                            </thead>
                            <tbody>
                                {certificateProduct.certificates.map(certificateVariant => (
                                    <tr>
                                        <td
                                            className="is-size-5-touch is-size-4-desktop"
                                            style={{
                                                width: '99%',
                                            }}
                                        >
                                            {certificateVariant.variant}
                                        </td>
                                        <td className="is-size-5-touch is-size-4-desktop">
                                            <a
                                                href={`https://assets.drwatson.co.uk/certificates/${certificateVariant.certificateFile}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="button is-theme-info is-medium has-text-weight-bold has-text-white"
                                            >
                                            View Certificate
                                            </a>

                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    </div>
                ))
            }
        </div>
        <Footer />

    </Layout>
);

export default CertificatesPage;
